import React, { useEffect, useState } from 'react'
import DataGrid from 'react-data-grid'
import { Icon } from '@iconify/react'
import { useLocation, useNavigate } from 'react-router-dom'
import Layout from '../../../brands/components/Layout'
import './index.css'
import { Dropdown } from 'react-bootstrap'
import { useAppDispatch, useAppSelector } from '../../../../redux/hook'
import { HIDE_LOADER, SHOW_LOADER } from '../../../../redux/slices/LoaderSlice'
import { viewResouce } from '../api'
import DelTask from '../components/DelTaskModal'
import { resoucelist } from '../slice/resoucesSlice'
import { annDateFormat } from '../../../dashboard/utils'

const ExploreResource: React.FC = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const queryParams = new URLSearchParams(location.search)
    const resourcename = queryParams.get('resource')
    const id = location.pathname.substring(
        location.pathname.lastIndexOf('/') + 1
    )
    const dispatch = useAppDispatch()
    const { resourceList } = useAppSelector((state) => state.adminResource)
    const [delpopup, setDelpopup] = useState<boolean>(false)
    const [taskid, setTaskId] = useState<string>('')

    useEffect(() => {
        dispatch(SHOW_LOADER())
        const getResources = async () => {
            try {
                const response = await viewResouce(id)
                dispatch(HIDE_LOADER())
                dispatch(resoucelist(response?.data))
            } catch (err) {
                // Handle any errors here
                console.error('Error fetching:', err)
                dispatch(HIDE_LOADER())
            }
        }

        getResources()
    }, [])

    const column = [
        {
            key: 'resourceName',
            name: 'Title',
            resizable: true,
            sortable: true,
        },
        {
            key: 'resourceType',
            name: 'Resource Type',
            resizable: true,
            sortable: true,
            renderCell: (props: any) => (
                <>
                    {props.row.resourceType.charAt(0).toUpperCase() +
                        props.row.resourceType.slice(1)}
                </>
            ),
        },
        {
            key: 'updated',
            name: 'Last Updated',
            resizable: true,
            sortable: true,
            renderCell: (props: any) => (
                <>{annDateFormat(props.row.lastModifiedOn)}</>
            ),
        },
        {
            key: 'actions',
            name: 'Actions',
            resizable: true,
            sortable: true,
            renderCell: (props: any) => (
                <>
                    <div className="dropdown-custom-link">
                        <Icon
                            onClick={() => {
                                navigate(
                                    `/resources/upload?id=${id}&resourceId=${props.row.resourceId}`,
                                    {
                                        state: {
                                            resourceid: props.row.resourceId,
                                            id: id,
                                        },
                                    }
                                )
                            }}
                            icon="bx:edit"
                            className="icon-primary"
                            cursor={'pointer'}
                        />
                        <Icon
                            onClick={() => {
                                setDelpopup(true)
                                setTaskId(props.row.resourceId)
                            }}
                            icon="icon-park-outline:delete"
                            className="icon-secondary"
                            cursor={'pointer'}
                        />

                        {props.row.type === 'Video' && (
                            <Icon icon="ph:play-fill" color="#4949C2" />
                        )}
                        <Dropdown>
                            <Dropdown.Toggle
                                variant="success"
                                id="dropdown-basic"
                            >
                                <Icon icon="mage:dots" />
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                <Dropdown.Item
                                    onClick={() =>
                                        navigate(
                                            `/resources/create-question/${props.row.resourceId}`,
                                            {
                                                state: {
                                                    resourceId:
                                                        props.row.resourceId,
                                                },
                                            }
                                        )
                                    }
                                >
                                    Create Questionnaire
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </>
            ),
        },
    ]

    const handleNoTaskClick = () => {
        navigate(`/resources/upload?id=${id}`)
    }

    function EmptyRowsRenderer() {
        return (
            <div className="no-data-message">
                There is no task.
                <span onClick={handleNoTaskClick} className="click-here">
                    Click here
                </span>{' '}
                to create a new one.
            </div>
        )
    }

    return (
        <div>
            <DelTask
                show={delpopup}
                onClose={setDelpopup}
                data={{ id: taskid }}
            />
            <Layout>
                <div className="page-information mb-3">
                    <div className="">
                        <div className="row">
                            <div className="col-sm-4">
                                <h4>{resourcename}</h4>
                            </div>
                            <div className="col-sm-8">
                                <div className="button-block justify-content-end d-flex button-block-resource">
                                    <a
                                        className="button button-primary"
                                        onClick={() =>
                                            navigate(
                                                `/resources/upload?id=${id}`,
                                                {
                                                    state: { id: id },
                                                }
                                            )
                                        }
                                    >
                                        UPLOAD TASK
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="table-wrapper grid-table-timeoff">
                    <DataGrid
                        className="data-grid-table"
                        columns={column}
                        rows={resourceList}
                        rowHeight={60}
                        headerRowHeight={35}
                        renderers={{ noRowsFallback: <EmptyRowsRenderer /> }}
                    />
                </div>
            </Layout>
        </div>
    )
}

export default ExploreResource
